/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 703
// module chunks = 0